import { cloneCourseDocument, type CourseDocument } from './CourseDocument';
export class CommandHistory {
  private undoStack: CourseDocument[] = [];
  private redoStack: CourseDocument[] = [];
  constructor(private limit = 50) {}
  capture(document: CourseDocument): void {
    this.undoStack.push(cloneCourseDocument(document));
    if (this.undoStack.length > this.limit) this.undoStack.shift();
    this.redoStack = [];
  }
  undo(current: CourseDocument): CourseDocument | null {
    const prev = this.undoStack.pop();
    if (!prev) return null;
    this.redoStack.push(cloneCourseDocument(current));
    return cloneCourseDocument(prev);
  }
  redo(current: CourseDocument): CourseDocument | null {
    const next = this.redoStack.pop();
    if (!next) return null;
    this.undoStack.push(cloneCourseDocument(current));
    return cloneCourseDocument(next);
  }
}
